import { ApiError } from '@postifoto/api-client';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createAppRouter } from './router';
import './styles.css';
import { isGuestPath } from './auth/guest-paths';
import { installErrorReporting } from './lib/error-reporting';

const queryClient = new QueryClient({
  defaultOptions: {
    // 4xx не повторяем: повтор не поможет, а 401 должен сразу вести на вход.
    queries: {
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    // Сессия истекла или отозвана — на экран входа (кроме экранов для гостя).
    onError: (error) => {
      if (
        error instanceof ApiError &&
        error.status === 401 &&
        !isGuestPath(window.location.pathname)
      ) {
        queryClient.clear();
        void router.navigate({ to: '/login' });
      }
    },
  }),
});

const router = createAppRouter(queryClient);

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

installErrorReporting();
